var cilMediaStepBackward = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M402.8,90.58a23.876,23.876,0,0,0-25.082,2.149L183.155,236.847h0a24,24,0,0,0,0,38.57l194.56,144.119A24,24,0,0,0,416,400.251V112.015A23.882,23.882,0,0,0,402.8,90.58ZM384,384.37,210.881,256.133,384,127.9Z' class='ci-primary'/><rect width='32' height='336' x='96' y='88' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilMediaStepBackward };

